import background1 from './images/home-more-bg1.svg'
import background2 from './images/home-more-bg2.svg'
import bannerEn from './images/home-banner-adguards-en.svg'
import bannerZh from './images/home-banner-adguards.svg'
import bannerDisplay from './images/home-banner-adguard-display.svg'
import iconInsurance from './images/icon-benifits-adguard-prevent.svg'
import iconSync from './images/icon-benifits-adguard-protect.svg'
import iconSafe from './images/icon-benifits-adguard-safe.svg'
import iconEasy from './images/icon-benifits-adguard-controll.svg'
import adguardBackground1 from './images/adguard-more-bg1.svg'
import adguardBackground2 from './images/adguard-more-bg2.svg'

export const getConstants = prop => Constants[prop]

const pageName = 'adguard'

export const appBanner = {
	pageName,
	bannerEn: bannerEn.url,
	bannerZh: bannerZh.url,
	bannerDisplay: bannerDisplay.url,
}

export const appBenifit = {
	title: getConstants('ADGUARD_LANDING_BENIFIT_TITLE'),
	subTitle: getConstants('ADGUARD_LANDING_BENIFIT_SUBTITLE'),
	list: [
		{
			title: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK1_TITLE'),
			before: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK1_BEFORE'),
			after: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK1_AFTER'),
			icon: iconInsurance.url,
		},
		{
			before: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK2_BEFORE'),
			after: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK2_AFTER'),
			title: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK2_TITLE'),
			icon: iconSafe.url,
		},
		{
			title: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK3_TITLE'),
			before: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK3_BEFORE'),
			after: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK3_AFTER'),
			icon: iconSync.url,
		},
		{
			title: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK4_TITLE'),
			before: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK4_BEFORE'),
			after: getConstants('ADGUARD_LANDING_BENIFIT_BLOCK4_AFTER'),
			icon: iconEasy.url,
		},
	],
}

export const appSale = {
	advanced: {
		title: getConstants('ADGUARD_LANDING_SALE_ADVANCE_TITLE'),
		subTitle: getConstants('ADGUARD_LANDING_SALE_ADVANCE_SUBTITLE'),
		originPrice: getConstants('ADGUARD_LANDING_SALE_ADVANCE_ORIGIN_PRICE'),
		edition: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_EDITION'),
		saleText1: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT1'),
		saleText2: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT2'),
		saleText3: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT3'),
		saleTip: getConstants('BOXCRYPTOR_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('BOXCRYPTOR_LANDING_SALE_UPDATE'),
	},
	pro: {
		title: getConstants('ADGUARD_LANDING_SALE_PRO_TITLE'),
		subTitle: getConstants('ADGUARD_LANDING_SALE_PRO_SUBTITLE'),
		originPrice: getConstants('ADGUARD_LANDING_SALE_PRO_ORIGIN_PRICE'),
		edition: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_EDITION'),
		saleText1: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT1'),
		saleText2: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT2'),
		saleText3: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT3'),
		saleTip: getConstants('BOXCRYPTOR_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('BOXCRYPTOR_LANDING_SALE_UPDATE'),
	},
	extra: {
		title: getConstants('ADGUARD_LANDING_SALE_LICENSE'),
		list: [
			getConstants('ADGUARD_LANDING_SALE_LICENSE_TEXT1'),
			getConstants('ADGUARD_LANDING_SALE_LICENSE_TEXT2'),
		],
	},
}

export const paidModal = {
	name: getConstants('ADGUARD_LANDING_SALE_PAID_NAME'),
	content: getConstants('ADGUARD_LANDING_SALE_PAID_CONTENT'),
	tip: getConstants('ADGUARD_LANDING_SALE_PAID_TIP'),
	price: getConstants('ADGUARD_LANDING_SALE_PAID_PRICE'),
	plan: getConstants('ADGUARD_LANDING_SALE_PLAN'),
	pro: {
		title: getConstants('ADGUARD_LANDING_SALE_PRO_TITLE'),
		originPrice: '¥ 556',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_PRO'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_360'),
	},
	advance: {
		title: getConstants('ADGUARD_LANDING_SALE_ADVANCE_TITLE'),
		originPrice: '¥ 916',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_ADVANCE'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_720'),
	},
}

export const appRecommend = {
	title: getConstants('ADGUARD_LANDING_RECOMMEND_TITLE'),
	subTitle: getConstants('ADGUARD_LANDING_RECOMMEND_SUBTITLE'),
	blocks: [
		{
			text: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK1_TEXT'),
			name: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK1_USER'),
		},
		{
			text: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK2_TEXT'),
			name: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK2_USER'),
		},
		{
			text: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK3_TEXT'),
			name: getConstants('ADGUARD_LANDING_RECOMMEND_BLOCK3_USER'),
		},
	],
}

export const appFaq = [1, 2, 3, 4, 5, 6, 7, 8].map(num => ({
	title: getConstants(`ADGUARD_LANDING_FAQ_DETAIL_TITLE${num}`),
	text: getConstants(`ADGUARD_LANDING_FAQ_DETAIL_TEXT${num}`),
}))

export const appMore = [
	{
		title: getConstants('EAGLE_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('EAGLE_LANDING_MORE_NUTSTORE_SUBTITLE'),
		src1: background1.url,
		src2: background2.url,
		texts1: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT3'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT4'),
		],
		texts2: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT6'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT7'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT8'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT9'),
		],
	},
	{
		class: 'adguard-landing-more',
		title: getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('ADGUARD_LANDING_MORE_NUTSTORE_SUBTITLE'),
		src1: adguardBackground1.url,
		src2: adguardBackground2.url,
		texts1: [
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT3'),
		],
		texts2: [
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT4'),
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('ADGUARD_LANDING_MORE_NUTSTORE_TEXT6'),
		],
	},
]

export const appHeader = {
	pageName,
}
